import {Component, DestroyRef, inject, OnInit} from "@angular/core";
import {BokkzIbDataService, IbRekenService, IncomeTaxEntity} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject, filter, Observable, shareReplay, take} from "rxjs";
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box2-inkomen-uit-ab',
  templateUrl: './box2-inkomen-uit-aanmerkelijk-belang.component.html',
  styleUrls: ['./box2-inkomen-uit-aanmerkelijk-belang.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class Box2InkomenUitAanmerkelijkBelangSamenvattingComponent implements OnInit {

  private dataService = inject(BokkzIbDataService);
  private destroyRef = inject(DestroyRef);
  private bokkzClient = inject(IbRekenService);
  public dataVisible$ = new BehaviorSubject<boolean>(false);

  readonly incomeTaxEntity$: Observable<IncomeTaxEntity> =
    this.dataService.incomeTaxEntity$.pipe(
      filter((data): data is IncomeTaxEntity => !!data?.sstRelationId),
      takeUntilDestroyed(this.destroyRef),
      shareReplay({bufferSize: 1, refCount: true})
    );

  public formGroup = new FormGroup({
    reguliereVoordelen: new FormControl<number | null>(0),
    fictieveReguliereVoordelen: new FormControl<number | null>(0),
    maximumBedragSchuldenBijVennootschappen: new FormControl<number | null>(0),
    eerderInHeffingBetrokkenSchuldBijVennootschappen: new FormControl<number | null>(0),
    totaalSchuldenBijVennootschappen: new FormControl<number | null>(0),
    eigenWoningSchuldenBijVennootschappen: new FormControl<number | null>(0),
    vervreemdingsVoordelen: new FormControl<number | null>(0),
    verkrijgingsPrijs: new FormControl<number | null>(0),
    aftrekbareKosten: new FormControl<number | null>(0),
    saldoAanmerkelijkBelang: new FormControl<number | null>(0),
  });

  ngOnInit(): void {
    this.incomeTaxEntity$.pipe(
      take(1),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.bokkzClient.getIncomeTaxReport(this.dataService.incomeTaxEntity.value.aangifte!).subscribe(details => {
        this.formGroup.reset({}, {emitEvent: false});
        this.formGroup.patchValue(details.specificatieBox2?.opbouw ?? {}, {emitEvent: false});
        this.formGroup.patchValue({saldoAanmerkelijkBelang : details.specificatieInkomenBox2?.opbouw?.saldoAanmerkelijkBelang}, {emitEvent: false});
        this.formGroup.disable({emitEvent: false});
        this.dataVisible$.next(true);
      });
    });
  }
}
